export default "__VITE_ASSET__60f1ba03__"